import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initTabs() {
    const tabs = document.querySelectorAll('.tab');
    const contents = document.querySelectorAll('.tab__content');
    const tabsContainer = document.querySelector('.tabs');

    function animateInitialState() {
        contents.forEach((content, index) => {
            content.style.zIndex = contents.length - index;
            gsap.to(content, {
                y: `${index * 2.5}rem`,
                duration: 0.75,
                ease: 'linear'
            });
        });
    }

    ScrollTrigger.create({
        trigger: tabsContainer,
        start: 'bottom bottom',
        onEnter: (self) => {
            animateInitialState();
            self.kill();
        }
    });

    function updateTabs() {
        const activeContent = document.querySelector('.tab__content.active');
        const activeIndex = Array.from(contents).indexOf(activeContent);
        
        contents.forEach((content, index) => {
            let position = (index - activeIndex + contents.length) % contents.length;
            if (content === activeContent) {
                gsap.to(content, {
                    duration: 0,
                    onComplete: () => {
                        gsap.to(content, {
                            zIndex: contents.length + 1,
                            duration: 0.5,
                            ease: 'linear'
                        });
                    }
                });
            } else {
                gsap.to(content, {
                    y: `${position * 2.5}rem`,
                    zIndex: contents.length - position,
                    duration: 0.5,
                    delay: 0.1,
                    ease: 'linear'
                });
            }
        });
    }

    function activateTab(tab, newContent) {
        const activeTab = document.querySelector('.tab.active');
        const activeContent = document.querySelector('.tab__content.active');
        const activeContentHeight = activeContent.offsetHeight;

        if (activeContent !== newContent) {
            gsap.to(activeContent, {
                y: -(activeContentHeight + 100),
                duration: 0.5,
                ease: 'linear',
                onComplete: () => {
                    activeTab.classList.remove('active');
                    tab.classList.add('active');
                    activeContent.classList.remove('active');
                    newContent.classList.add('active');
                    updateTabs();

                    gsap.to(newContent, {
                        y: 0,
                        duration: .15,
                        ease: 'linear'
                    });
                }
            });
        }
    }

    tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
            const tabId = tab.id.replace('tab-button-', '');
            const newContent = document.getElementById(`tab-content-${tabId}`);
            activateTab(tab, newContent);
        });
    });

    contents.forEach((content) => {
        content.addEventListener('click', (event) => {
            const contentId = content.id.replace('tab-content-', '');
            const newTab = document.getElementById(`tab-button-${contentId}`);
            activateTab(newTab, content);
        });
    });
}